export const TestimonialVisibility = Object.freeze({
    private: { value: "private", label: "Private" },
    public: { value: "public", label: "Public" },

    getAllOptions() {
        let options = [];

        Object.keys(this).forEach((key) => {
            if (typeof this[key] !== "object") {
                return;
            }

            options.push(this[key]);
        });

        return options;
    },
});
